module.exports = __webpack_public_path__ + "img/img_join.a6be1242.jpg";